// VerdictSpectrum.js — the verdict shown as the scale it lives on, not a bare pill.
// A four-stop rewrite spectrum (Low on its own · Structural · Targeted · Just polish) with
// this unit's band marked. The scale teaches what "Polish" means by showing what it is
// NOT — teach-while-placing, the same move as the script-level champion/voice bars.

import React from 'react';
import PropTypes from 'prop-types';
import { BANDS, BAND_SPECTRUM } from './wikiContent';
import { InfoDot } from './InfoUI';

// left→right colour ramp matching the bands (heaviest rewrite → lightest touch)
const SEG = {
  cut_or_combine: { on: '#b71c2c', off: '#f6d3d7' },
  rework:         { on: '#b34c00', off: '#f7ddc6' },
  polish:         { on: '#9a7400', off: '#f1e3b6' },
  keep:           { on: '#0a7a37', off: '#cdeed8' },
};
const NAVY = '#14536e';

export default function VerdictSpectrum({ band, label, onOpenWiki }) {
  const activeIdx = BAND_SPECTRUM.indexOf(band);
  const article = band && BANDS[band] ? { ...BANDS[band], kicker: 'Verdict' } : null;
  const answer = BANDS[band]?.spectrumLabel || BANDS[band]?.label;
  const answerColor = (SEG[band] && SEG[band].on) || '#0f172a';
  // Short, like the role + lens lines: the question, the one-word answer (colour-coded by
  // band), and the (i) does the explaining (the full Start-over→Just-polish scale lives there).
  return (
    <div className="d-flex align-items-center flex-wrap" style={{ gap: 7 }}>
      <span style={{ color: NAVY, fontWeight: 600, fontSize: '.92rem' }}>{label || 'How much rework does it need?'}</span>
      {answer && <span style={{ fontWeight: 700, fontSize: '.92rem', color: answerColor }}>{answer}</span>}
      {article && onOpenWiki && <InfoDot article={article} onOpen={onOpenWiki} />}
    </div>
  );
}
VerdictSpectrum.propTypes = {
  band: PropTypes.string,
  label: PropTypes.string,
  onOpenWiki: PropTypes.func,
};
